import StyledSvg from 'icons/StyledSvg';
import { IconProps } from 'icons/types';

// Icon for ">" arrow
export const ArrowRight = ({ color, size = '204', height = '20' }: IconProps) => {
  return (
    <StyledSvg
      width={size}
      height={height}
      color={color || 'currentColor'}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.64851 5.64648L13.0021 10L8.64851 14.3536L7.94141 13.6465L11.5879 10L7.94141 6.35359L8.64851 5.64648Z"
        fill="#666666"
      />
    </StyledSvg>
  );
};
